/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { SimpleZoomControl } from '@/components/reader/SimpleZoomControl';

import { FunctionComponent, useCallback, useContext } from 'react';
import { PageNumberControl, UiContext } from '@allenai/pdf-components';

interface Props {
  showPageNumber?: boolean;
  showOutline?: boolean;
  showThumbnail?: boolean;
}

export const Header: FunctionComponent<Props> = (props) => {
  const {
    showPageNumber = false,
    showOutline = false,
    showThumbnail = false,
  } = props;
  const {
    isShowingOutline,
    isShowingThumbnail,
    setIsShowingOutline,
    setIsShowingThumbnail,
  } = useContext(UiContext);

  const handleShowOutline = useCallback(() => {
    setIsShowingOutline(!isShowingOutline);
    setIsShowingThumbnail(false);
  }, [isShowingOutline]);

  const handleShowThumbnail = useCallback(() => {
    setIsShowingThumbnail(!isShowingThumbnail);
    setIsShowingOutline(false);
  }, [isShowingThumbnail]);

  return (
    <div className="reader__header">
      {showPageNumber && (
        <div className="header-control">
          <PageNumberControl />
        </div>
      )}
      <div className="header-control">
        <SimpleZoomControl />
      </div>
      {showOutline && (
        <div className="header-control">
          <a onClick={handleShowOutline}>Outline</a>
        </div>
      )}
      {showThumbnail && (
        <div className="header-control">
          <a onClick={handleShowThumbnail}>Thumbnail</a>
        </div>
      )}
    </div>
  );
};
